<template>
    <div class="width100">
        <b-modal id="modalInfo" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>

            </template>
            <div class="d-block">
                <div v-if="errors2.length" class="alert alert-danger text-center" role="alert">
                    <p v-for="(error, key) in errors2" :key="key">{{ error }}</p>
                </div>
                <div v-if="msgs2.length" class="alert alert-success text-center" role="alert">
                    <p v-for="(msg, key) in msgs2" :key="key">{{ msg }}</p>
                </div>
            </div>
        </b-modal>
        <b-modal id="modalInfoPanne" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>
                {{panneTitre}}
            </template>
            <div class="d-block">
                <div class="row">
                    <div class="col-3">
                        Déclaration:
                    </div>
                    <div class="col-9">
                        {{panneDate}}
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-3 border-top">
                        Rendez vous:
                    </div>
                    <div class="col-9 border-top">
                        {{panneDateRDV}}
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-3 border-top">
                        Défaut:
                    </div>
                    <div class="col-9 border-top">
                        {{panneDefaut}}
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-3 border-top">
                        Solution:
                    </div>
                    <div class="col-9 border-top">
                        {{panneSolution}}
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-3 border-top">
                        Panne réparée:
                    </div>
                    <div class="col-9 text-center border-top">
                        <i v-if="panneResolu == true" class="fa-solid fa fa-check text-success fa-2x"></i>

                        <i v-if="panneResolu == false" class="fa-solid fa-xmark text-danger fa-2x"></i>
                    </div>
                </div>


            </div>
        </b-modal>

        <div class="row">
            <div class="col-10  offset-1">
                <div class="row" >
                    <div v-for="(panne, keyPanne) in listPanne" :key="keyPanne" class="colSolu col-md-12 col-lg-4">
                        <div class="thtab userList col-12 text-center rounded" @click="ouvrePanne(keyPanne)" v-if="panne.resolu==0">
                            {{afficheDateFr(panne.date)}} {{panne.titre.substring(0, 20)}} <i v-if="panne.vu == 1" class="fa-solid fa fa-check text-warning"></i>
                        </div>
                        <div class="thtabOrange userList col-12 text-center rounded" @click="ouvrePanne(keyPanne)" v-if="panne.resolu==1">
                            {{afficheDateFr(panne.date)}} {{panne.titre.substring(0, 20)}} <i v-if="panne.vu == 1" class="fa-solid fa fa-check text-warning"></i>
                        </div>
                    </div>
                </div>

                <br/>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-danger" block @click="returnAMaintenance()">Retour</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "PanneHistorique",
        props: ['token', 'site', 'user', 'racine', 'machine', 'userId','machineType','idModif','systemeClient'],
        data() {
            return {
                titrePanne:null,defautPanne:null, errors2:[], msgs2:{1:'ytegfg'},
                blob2:null,dataUrl2:null,image:null, listPanne:[], panneTitre:'',panneDate:'',
                panneDateRDV:'',panneDefaut:'',panneSolution:'', panneResolu:false
            };
        },
        methods:
            {
                afficheDateFr(date)
                {
                    var today = new Date(date)
                    var month = today.getMonth() + 1
                    var day = today.getDate()
                    if (month < 10) {
                        month = "0" + month
                    }
                    if (day < 10) {
                        day = "0" + day
                    }

                    return day+ '/' + month+'/'+today.getFullYear()
                },
                histoPanne()
                {
                    fetch(this.racine + this.site + 'api/pannes?machine='+this.machine['id']+'&order[date]=desc', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        console.log(response)
                        if (response.status == 200)
                        {
                            response.json().then(json => {
                                if (json != undefined) {
                                    console.log(json)
                                    this.listPanne = json['hydra:member']
                                }
                            })
                        }
                    })

                },
                ouvrePanne(keyPanne)
                {
                    this.$bvModal.show('modalInfoPanne')
                    this.panneTitre = this.listPanne[keyPanne].titre
                    this.panneDate = this.afficheDateFr(this.listPanne[keyPanne].date)
                    if(this.listPanne[keyPanne].dateRendezVous!=undefined)
                    {
                        this.panneDateRDV = this.afficheDateFr(this.listPanne[keyPanne].dateRendezVous)
                    }
                    else
                    {
                        this.panneDateRDV = ''
                    }
                    this.panneDefaut = this.listPanne[keyPanne].defaut
                    this.panneSolution = this.listPanne[keyPanne].solution
                    if(this.listPanne[keyPanne].resolu==1)
                    {
                        this.panneResolu = true
                    }
                    else
                    {
                        this.panneResolu = false
                    }
                },
                returnAMaintenance()
                {
                    this.$emit('returnMaintenanceHistoPanne')
                }

            },
        mounted() {
            this.histoPanne()
        }
    }
</script>

<style scoped>

</style>